/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect, useState, useMemo, useRef,
} from 'react';
import { Controller, useForm } from 'react-hook-form';
import moment from 'moment';
import {
  makeStyles, TableContainer, Table, TableBody, TableCell, TableRow, Grid, Button, useTheme,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/es';
import { connect, useDispatch } from 'react-redux';
import { GET_HISTORY_CONSUMPTION_DASHBOARD, GET_REQUEST_DASHBOARD, CLEAR_SERVICES_DATA_DASHBOARD } from '../../../types/license.type';
import CustomTableMovements from '../../../components/form/Table/CustomTableMovements';
import AlertConfirm from '../../../components/crosscutting/confirmationWindows/AlertConfirm';
import { getHistoryConsumptionDataDashboardAction, getClearHistoryConsumptionDataDashboardAction } from '../../../actions/license.action';
import { clearMessageAlertAction } from '../../../actions/general.action';
import {
  URL_REPORT_CONSUMO_CUSTOM, API_SEGURIDAD,
} from '../../../config/config';
import ArrowBackMovements from '../../../assets/img/iconos/license/ArrowBackMovements.svg';
import FirmayaServicesDashboardDark from '../../../assets/img/dashboard/firmaya/dashboard_dark.svg';
import FirmayaServicesDashboardLight from '../../../assets/img/dashboard/firmaya/dashboard_light.svg';
import MyselfcertServicesDashboardDark from '../../../assets/img/dashboard/myselfcert/dashboard_dark.svg';
import MyselfcertServicesDashboardLight from '../../../assets/img/dashboard/myselfcert/dashboard_light.svg';
import BiometrixIaServicesDashboardDark from '../../../assets/img/dashboard/biometrixia/dashboard_dark.svg';
import BiometrixIaServicesDashboardLight from '../../../assets/img/dashboard/biometrixia/dashboard_light.svg';
import BiometriaServicesDashboardDark from '../../../assets/img/dashboard/biometria/dashboard_dark.svg';
import BiometriaServicesDashboardLight from '../../../assets/img/dashboard/biometria/dashboard_light.svg';
import CorreoCEServicesDashboardDark from '../../../assets/img/dashboard/correoce/dashboard_dark.svg';
import CorreoCEServicesDashboardLight from '../../../assets/img/dashboard/correoce/dashboard_light.svg';
import CorreoBCServicesDashboardDark from '../../../assets/img/dashboard/correobc/dashboard_dark.svg';
import CorreoBCServicesDashboardLight from '../../../assets/img/dashboard/correobc/dashboard_light.svg';
import AniServicesDashboardDark from '../../../assets/img/dashboard/ani/dashboard_dark.svg';
import AniServicesDashboardLight from '../../../assets/img/dashboard/ani/dashboard_light.svg';
import GseServicesDashboardLight from '../../../assets/img/dashboard/gse/dashboard_light.svg';
import GseServicesDashboardDark from '../../../assets/img/dashboard/gse/dashboard_dark.svg';
import DashboardDownloadIcon from '../../../assets/img/iconos/license/DashboardDownloadIcon.svg';
import WarningIcon from '../../../components/IconsLibrary/WarningIcon';

const getMulishText = (fontWeight, color) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize: '14px',
  fontWeight,
  color,
});

const alertStyles = (
  theme, firstImageIcon, marginTopImage, minWidthButtonAcept,
) => ({
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom: 15,
  },
  firstImage: firstImageIcon,
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  styleButtonCancel: {
    backgroundColor: '#FFFFFF',
    color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
    border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
  },
  styleTitle: {
    fontSize: '17px',
    fontWeight: 500,
    marginTop: '-25px',
    color: '#575756',
  },
  styleButtonAcept: {
    minWidth: minWidthButtonAcept,
  },
});

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    borderRadius: '30px',
    opacity: 1,
    padding: '5px',
    marginTop: '20px',
  },
  title: {
    ...theme.backOffice.configurations.title,
    fontWeight: 700,
    fontSize: '31px',
    paddingTop: '6px',
    paddingLeft: '20px',
  },
  paperGroup: {
    backgroundColor: '#fff',
    margin: 20,
    borderRadius: 10,
    border: '1px solid #32ACDE',
    padding: 20,
    minHeight: 300,
  },
  icon: {
    ...theme.backOffice.configurations.title,
    fontWeight: 700,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '27px',
    paddingLeft: '20px',
  },
  table: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  tableCellHead: {
    height: '58.28px',
    fontWeight: 'bold',
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: 'white',
    },
    '&:first-child': {
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
    },
    '&:last-child': {
      borderTopRightRadius: '10px',
      borderBottomRightRadius: '10px',
    },
    ...theme.miplan.tablePlanTable,
  },
  paperStyle: {
    padding: '20px',
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.2)',
  },
  boxHeadFeatures: {
    fontWeight: 'bold',
    color: '#7B7B7B',
    backgroundColor: '#F9F9F9',
  },
  formControl: {
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      color: '#202427',
    },
  },
  dateCustom: {
    '& .MuiIconButton-root': {
      color: '#1C1B1F',
    },
    '& .MuiOutlinedInput-root': {
      borderColor: 'red',
    },
  },
  button: {
    backgroundColor: '#E55200',
    paddingLeft: '19px',
    paddingRight: '19px',
    paddingBottom: '8px',
    paddingTop: '9px',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#E55200',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
    },
  },
  textButton: {
    ...getMulishText(600, 'white'),
  },
}));

/**
 * View Movements
 * @param {*} props
 * @returns
 */
const Movements = (props) => {
  const {
    history, getHistoryConsumptionDashboard, getRequestDashboard, getHistoryConsumptionDataDashboard, showMessageAlert, clearMessageAlert, getClearHistoryConsumptionDataDashboard,
  } = props;
  const {
    handleSubmit, errors, control, setValue, clearErrors, trigger,
  } = useForm({
    mode: 'onChange',
  });
  const theme = useTheme();

  const [fromDate, setFromDate] = useState(null);
  const [untilDate, setUntilDate] = useState(null);
  const [isSearch, seIsSearch] = useState(false);
  const [dataClient, setDataClient] = useState({});
  const [movementsData, setMovementsData] = useState([]);
  const [openAlertConfirm, setOpenAlertConfirm] = useState(false);
  const [messagesAlertView, setMessagesAlertView] = useState({});
  const [page, setPage] = React.useState(0);
  const [totalDaysLimit, setTotalDaysLimit] = React.useState(1);
  const [isRangeExceeded, setIsRangeExceeded] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const ignoreNextEffect = useRef(false);
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;
  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);

  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    const totalDashboardDaysRange = Number(sessionStorage.getItem('totalDashboardDaysRange')) || 1;
    setTotalDaysLimit(totalDashboardDaysRange);
    setValue('fromDate', moment().subtract(totalDashboardDaysRange, 'days'));
    setFromDate(moment().subtract(totalDashboardDaysRange, 'days'));
    setValue('untilDate', moment());
    setUntilDate(moment());
  }, []);

  useEffect(() => {
    if (ignoreNextEffect.current) {
      ignoreNextEffect.current = false;
      return;
    }
    if (Object.keys(getHistoryConsumptionDashboard).length > 0) {
      setDataClient({
        customerName: getHistoryConsumptionDashboard?.customerName,
        descriptionService: getHistoryConsumptionDashboard?.descriptionService,
        documentNumber: getHistoryConsumptionDashboard?.documentNumber,
        documentType: getHistoryConsumptionDashboard?.documentType,
        email: getHistoryConsumptionDashboard?.email,
        personType: getHistoryConsumptionDashboard?.personType,
        phoneNumber: getHistoryConsumptionDashboard?.phoneNumber,
        serviceName: getHistoryConsumptionDashboard?.serviceName,
      });
      const updatedContracts = getHistoryConsumptionDashboard.consumptionDetailHistory?.map(
        (item) => ({
          description: item.serviceFeatureDescription,
          event: item.event,
          quantity: item.quantity,
          dateTime: new Date(item.consumptionDate).toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          }).replace(',', ''),
          state: 0,
        }),
      );
      setMovementsData(updatedContracts);
      seIsSearch(false);
    } else if (!isSearch) {
      dispatch({
        type: GET_HISTORY_CONSUMPTION_DASHBOARD,
        payload: {},
      });
      dispatch({
        type: GET_REQUEST_DASHBOARD,
        payload: {},
      });
      history.push('/admin/dashboard');
    }
    if (isSearch && Object.keys(getHistoryConsumptionDashboard).length === 0) {
      seIsSearch(false);
      setMovementsData([]);
    }
  }, [getHistoryConsumptionDashboard]);

  const processText = (text) => text.split(/(<strong>.*?<\/strong>)/g).map((part, index) => {
    if (part.startsWith('<strong>') && part.endsWith('</strong>')) {
      const content = part.replace('<strong>', '').replace('</strong>', '');
      // eslint-disable-next-line react/no-array-index-key
      return <strong key={index}>{content}</strong>;
    }
    return part;
  });

  useEffect(() => {
    if (showMessageAlert) {
      setOpenAlertConfirm(true);
      setMessagesAlertView({
        tituloModal: processText(showMessageAlert?.mensajeModal),
        textButtonAcept: 'Aceptar',
        mensajeModal: '',
        onCancel: false,
        messageAlert: alertStyles(theme, OwnWarningIcon, 40, '40%'),
        showClose: false,
        isOnlyMessage: false,
      });
    }
  }, [showMessageAlert]);

  const onBack = () => {
    dispatch({
      type: GET_HISTORY_CONSUMPTION_DASHBOARD,
      payload: {},
    });
    dispatch({
      type: GET_REQUEST_DASHBOARD,
      payload: {},
    });
    dispatch({
      type: CLEAR_SERVICES_DATA_DASHBOARD,
      payload: {},
    });
    seIsSearch(false);
    setDataClient({});
    history.push('/admin/dashboard');
  };

  const columnData = [
    {
      id: 'description',
      label: 'Descripción',
      minWidth: 100,
      position: 1,
      isSortable: true,
      sortPropertyName: 'description',
    },
    {
      id: 'event',
      label: 'Evento',
      minWidth: 100,
      position: 2,
      isSortable: true,
      sortPropertyName: 'event',
    },
    {
      id: 'quantity',
      label: 'Cantidad',
      minWidth: 100,
      position: 3,
      isSortable: true,
      sortPropertyName: 'quantity',
    },
    {
      id: 'dateTime',
      label: 'Fecha y hora',
      minWidth: 100,
      position: 4,
      isSortable: true,
      sortPropertyName: 'dateTime',
    },
  ];

  const getLogoService = (serviceName = 'gse', mode) => {
    switch (serviceName.toLowerCase()) {
      case 'firmaya':
        return mode === 'dark' ? FirmayaServicesDashboardDark : FirmayaServicesDashboardLight;
      case 'myselfcert':
        return mode === 'dark' ? MyselfcertServicesDashboardDark : MyselfcertServicesDashboardLight;
      case 'biometria':
        return mode === 'dark' ? BiometriaServicesDashboardDark : BiometriaServicesDashboardLight;
      case 'biometrixia':
        return mode === 'dark' ? BiometrixIaServicesDashboardDark : BiometrixIaServicesDashboardLight;
      case 'correoce':
        return mode === 'dark' ? CorreoCEServicesDashboardDark : CorreoCEServicesDashboardLight;
      case 'correobc':
        return mode === 'dark' ? CorreoBCServicesDashboardDark : CorreoBCServicesDashboardLight;
      case 'ani':
        return mode === 'dark' ? AniServicesDashboardDark : AniServicesDashboardLight;
      case 'biocapture':
        return mode === 'dark' ? BiometrixIaServicesDashboardDark : BiometrixIaServicesDashboardLight;
      case 'mbssfacial':
        return mode === 'dark' ? BiometrixIaServicesDashboardDark : BiometrixIaServicesDashboardLight;
      case 'myselfcertns':
        return mode === 'dark' ? MyselfcertServicesDashboardDark : MyselfcertServicesDashboardLight;
      default:
        return mode === 'dark' ? GseServicesDashboardDark : GseServicesDashboardLight;
    }
  };

  const handleSearch = (data) => {
    seIsSearch(true);
    const fromDateParam = data.fromDate.startOf('day').format('YYYY-MM-DD');
    const untilDateParam = data.untilDate.startOf('day').format('YYYY-MM-DD');

    const request = {
      documentType: getRequestDashboard?.documentType,
      documentNumber: getRequestDashboard?.documentNumber,
      serviceName: getRequestDashboard?.serviceName,
      serviceFeatureCode: getRequestDashboard?.serviceFeatureCode,
      startDate: fromDateParam,
      endDate: untilDateParam,
      isSupervised: getRequestDashboard?.isSupervised,
    };
    ignoreNextEffect.current = true;
    getClearHistoryConsumptionDataDashboard();
    getHistoryConsumptionDataDashboard(request, undefined, undefined, 0, 100);
    setPage(0);
  };

  const handleClickMovementsDownload = async () => {
    const isValid = await trigger();
    if (!isValid) {
      return;
    }
    const pDateStart = fromDate ? moment(fromDate).format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD');
    const pDateFinal = untilDate ? moment(untilDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    const finalUrl = URL_REPORT_CONSUMO_CUSTOM
      .replace('{{pfechadesde}}', pDateStart)
      .replace('{{pfechahasta}}', pDateFinal)
      .replace('{{ptipodocumento}}', getRequestDashboard?.documentType)
      .replace('{{pnumerodocumento}}', getRequestDashboard?.documentNumber)
      .replace('{{pnombreproducto}}', getRequestDashboard?.serviceName)
      .replace('{{pcaracteristicaservicio}}', getRequestDashboard?.serviceFeatureCode)
      .replace('{{psupervisado}}', getRequestDashboard?.isSupervised.toString());
    const urlVerify = `${API_SEGURIDAD}/api/redirect/verify?url=${encodeURI(finalUrl)}`;
    const newTab = window.open(urlVerify, '_blank');
    if (newTab) {
      const link = document.createElement('a');
      link.href = finalUrl;
      link.setAttribute('download', '');
      newTab.document.body.appendChild(link);
      link.click();
      newTab.document.body.removeChild(link);
    } else {
      // No se puede abrir el tab
    }
  };

  const confirmLimitDate = () => {
    setValue('fromDate', '');
    setFromDate(null);
    setValue('untilDate', '');
    setUntilDate(null);
    seIsSearch(false);
    setOpenAlertConfirm(false);
    clearMessageAlert();
  };

  const handleChangePageTable = (event, newPage, pRowsPerPage) => {
    const numRows = pRowsPerPage;
    const last = movementsData?.length;
    if (last < (newPage + 1) * numRows) {
      if (movementsData?.length < getHistoryConsumptionDashboard?.totalRecords) {
        const dateStart = fromDate ? moment(fromDate).format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD');
        const dateFinal = untilDate ? moment(untilDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        const request = {
          documentType: getRequestDashboard?.documentType,
          documentNumber: getRequestDashboard?.documentNumber,
          serviceName: getRequestDashboard?.serviceName,
          serviceFeatureCode: getRequestDashboard?.serviceFeatureCode,
          startDate: dateStart,
          endDate: dateFinal,
          isSupervised: getRequestDashboard?.isSupervised,
        };
        getHistoryConsumptionDataDashboard(request, undefined, undefined, last, 100);
        seIsSearch(true);
      }
    }
    setPage(newPage);
  };

  const getPersonTypeLabel = (type = 'J') => {
    if (type === 'N') return 'Natural';
    return 'Jurídica';
  };

  return (
    <>
      <Container component="main" maxWidth="lg">
        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.titleContainer}>
            <IconButton onClick={onBack}>
              <img src={ArrowBackMovements} alt="Back Icon" className={classes.icon} />
            </IconButton>
            <Typography color="primary" variant="h4" className={classes.title}>
              Movimiento del producto
            </Typography>
          </Box>
          <Paper elevation={3} className={classes.paperGroup}>
            <TableContainer>
              <Table
                stickyHeader
                className={classes.table}
                aria-labelledby="tableTitle"
                size="small"
                aria-label="customized table"
                style={{
                  tableLayout: 'fixed', paddingTop: '18px', paddingRight: '30px', paddingLeft: '30px', borderSpacing: '0 12px',
                }}
              >
                <TableBody>
                  <TableRow
                    role="checkbox"
                    colSpan={2}
                    style={{ borderBottom: 'none' }}
                  >
                    <TableCell className={classes.tableCellHead}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={getLogoService(dataClient?.serviceName, 'light')}
                          alt="IconLight"
                          style={{
                            marginRight: '20px',
                            marginLeft: '20px',
                            width: '20px',
                            height: '20px',
                            objectFit: 'contain',
                          }}
                        />
                        <Typography classes={{ body1: classes.columnStyleParent }} style={{ fontWeight: 700 }}>
                          {dataClient?.descriptionService}
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ width: '100%', paddingBottom: '30px' }}>
              <Grid
                container
                alignItems="center"
                style={{
                  paddingTop: '18px',
                  paddingRight: '30px',
                  paddingLeft: '30px',
                  borderSpacing: '0px 12px',
                }}
              >
                <Grid item xs={12}>
                  <Paper className={classes.paperStyle}>
                    <Typography style={{ color: '#E55200', fontSize: '17px', fontWeight: 600 }}>
                      Información del cliente
                    </Typography>
                    <br />
                    <Typography style={{ color: '#293233', fontSize: '15px', fontWeight: 400 }}>
                      Nombre y Razon social:
                      {' '}
                      <span style={{ color: '#009BDD', fontWeight: 700 }}>{dataClient?.customerName}</span>
                    </Typography>
                    <br />
                    <Typography component="div" style={{ color: '#293233', fontSize: '15px', fontWeight: 400 }}>
                      <Box display="flex" flexWrap="wrap">
                        <span style={{ marginRight: '25px' }}>
                          Tipo de documento:
                          {' '}
                          <span style={{ color: '#009BDD', fontWeight: 700 }}>{dataClient?.documentType}</span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          ID Cliente:
                          {' '}
                          <span style={{ color: '#009BDD', fontWeight: 700 }}>{dataClient?.documentNumber}</span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          Tipo de persona:
                          {' '}
                          <span style={{ color: '#009BDD', fontWeight: 700 }}>{getPersonTypeLabel(dataClient?.personType)}</span>
                        </span>
                        <span style={{ marginRight: '25px' }}>
                          Telefono:
                          {' '}
                          <span style={{ color: '#009BDD', fontWeight: 700 }}>{dataClient?.phoneNumber}</span>
                        </span>
                        <span>
                          Correo:
                          {' '}
                          <span style={{ color: '#009BDD', fontWeight: 700 }}>{dataClient?.email}</span>
                        </span>
                      </Box>
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </div>
            <div style={{ paddingLeft: '30px', paddingRight: '30px' }}>
              <Card style={{
                borderRadius: '16px',
              }}
              >
                <Box className={classes.boxHeadFeatures} style={{ padding: '20px' }}>
                  <form noValidate autoComplete="off" onSubmit={handleSubmit(handleSearch)}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              required: 'Campo obligatorio',
                              validate: {
                                validDate: (value) => {
                                  const parsed = moment(value, 'DD/MM/YYYY', true);
                                  const minDate = moment('01/01/2000', 'DD/MM/YYYY');
                                  const maxDate = moment();
                                  if (!parsed.isValid()) {
                                    return 'Fecha inválida, el formato debe ser dd/MM/yyyy';
                                  }
                                  if (parsed.isBefore(minDate)) {
                                    return 'Fecha mínima permitida 01/01/2000';
                                  }
                                  if (parsed.isAfter(maxDate)) {
                                    setValue('untilDate', '');
                                    setUntilDate(null);
                                    return 'La fecha no puede ser mayor a hoy';
                                  }
                                  return true;
                                },
                              },
                            }}
                            defaultValue={fromDate}
                            render={() => (
                              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  className={classes.dateCustom}
                                  variant="inline"
                                  inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  label="Fecha desde"
                                  size="small"
                                  color="primary"
                                  value={fromDate}
                                  maxDate={new Date()}
                                  onChange={(date) => {
                                    setValue('fromDate', moment(date));
                                    setFromDate(moment(date));
                                    if (
                                      moment(date, 'DD/MM/YYYY', true).isValid()
                                    && !moment(date).isBefore(moment('01/01/2000', 'DD/MM/YYYY'))
                                    ) {
                                      clearErrors('fromDate');
                                      if (untilDate) {
                                        const selectedStart = moment(date).startOf('day');
                                        const selectedEnd = moment(untilDate).startOf('day');
                                        if (!selectedStart.isAfter(selectedEnd)) {
                                          const diffDays = selectedEnd.diff(selectedStart, 'days');
                                          setIsRangeExceeded(diffDays > totalDaysLimit);
                                        } else {
                                          setIsRangeExceeded(false);
                                        }
                                      }
                                    }
                                  }}
                                  autoOk
                                  error={!!errors.fromDate}
                                  helperText={errors.fromDate ? errors.fromDate.message : ''}
                                  InputProps={{
                                    style: {
                                      borderRadius: '10px',
                                      boxShadow: '1px 5px 5px #d7d7d7',
                                      backgroundColor: '#FFFFFF',
                                    },
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                          <Controller
                            name="untilDate"
                            control={control}
                            rules={{
                              required: 'Campo obligatorio',
                              validate: {
                                validDate: (value) => {
                                  const parsed = moment(value, 'DD/MM/YYYY', true);
                                  const minDate = fromDate ? moment(fromDate) : moment();
                                  const maxDate = moment();
                                  if (!parsed.isValid()) {
                                    return 'Fecha inválida, el formato debe ser dd/MM/yyyy';
                                  }
                                  if (parsed.isBefore(minDate, 'day')) {
                                    return `La fecha debe ser igual o posterior a ${minDate.format('DD/MM/YYYY')}`;
                                  }
                                  if (parsed.isAfter(maxDate, 'day')) {
                                    return 'La fecha no puede ser mayor a hoy';
                                  }
                                  return true;
                                },
                              },
                            }}
                            defaultValue={untilDate}
                            render={() => (
                              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  className={classes.dateCustom}
                                  variant="inline"
                                  inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  label="Fecha hasta"
                                  size="small"
                                  color="primary"
                                  value={untilDate}
                                  minDate={fromDate ? moment(fromDate).toDate() : moment().toDate()}
                                  maxDate={moment().toDate()}
                                  onChange={(date) => {
                                    setValue('untilDate', moment(date));
                                    setUntilDate(moment(date));
                                    clearErrors('untilDate');
                                    if (fromDate) {
                                      const selectedStart = moment(fromDate).startOf('day');
                                      const selectedEnd = moment(date).startOf('day');
                                      if (!selectedEnd.isBefore(selectedStart)) {
                                        const diffDays = selectedEnd.diff(selectedStart, 'days');
                                        setIsRangeExceeded(diffDays > totalDaysLimit);
                                      } else {
                                        setIsRangeExceeded(false);
                                      }
                                    }
                                  }}
                                  autoOk
                                  error={!!errors.untilDate}
                                  helperText={errors.untilDate ? errors.untilDate.message : ''}
                                  InputProps={{
                                    style: {
                                      borderRadius: '10px',
                                      boxShadow: '1px 5px 5px #d7d7d7',
                                      backgroundColor: '#FFFFFF',
                                    },
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Button
                          className={classes.button}
                          style={{ width: '85%' }}
                          type="submit"
                          disabled={!!isSearch || isRangeExceeded}
                        >
                          <Typography className={classes.textButton}>Buscar</Typography>
                        </Button>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Box display="flex" alignItems="center" justifyContent="end">
                          <Button
                            type="button"
                            className={classes.button}
                            style={{ width: '43%' }}
                            onClick={handleClickMovementsDownload}
                            disabled={!fromDate || !untilDate || !moment(fromDate).isValid() || !moment(untilDate).isValid() || errors.fromDate || errors.untilDate}
                          >
                            <img src={DashboardDownloadIcon} alt="ExcelIcon" style={{ marginRight: 8 }} />
                            <Typography className={classes.textButton}>Excel</Typography>
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
                <Grid item xs={12} className={classes.tableContainer}>
                  { isSearch ? (
                    <div style={{
                      display: 'flex', justifyContent: 'center', marginTop: '13px', paddingBottom: '13px',
                    }}
                    >
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    </div>
                  ) : (
                    <CustomTableMovements
                      columns={columnData}
                      data={movementsData}
                      enablePagination
                      styleTableContainer={{
                        width: 'auto', backgroundColor: '#FFFFFF', borderRadius: 0,
                      }}
                      styleTableCell={{
                        ...getMulishText(400, '#000000'),
                        textAlign: 'left',
                      }}
                      styleTableHead={{ textAlign: 'left' }}
                      handleChangePageTable={handleChangePageTable}
                      setPage={setPage}
                      page={page}
                      countRecordsList={getHistoryConsumptionDashboard?.totalRecords ?? 0}
                      rowsPerPage={rowsPerPage}
                      setRowsPerPage={setRowsPerPage}
                    />
                  )}
                </Grid>
              </Card>
            </div>
          </Paper>
        </Paper>
      </Container>
      <AlertConfirm
        isOpen={openAlertConfirm}
        tituloModal={messagesAlertView?.tituloModal}
        textButtonAcept={messagesAlertView?.textButtonAcept}
        mensajeModal={messagesAlertView?.mensajeModal}
        handleAccept={messagesAlertView?.handleAccept ? messagesAlertView?.handleAccept : () => confirmLimitDate()}
        onCancel={messagesAlertView?.onCancel}
        messageAlert={messagesAlertView?.messageAlert}
        showClose={messagesAlertView?.showClose}
        isOnlyMessage={messagesAlertView?.isOnlyMessage}
      />
    </>
  );
};

const mapStateToProps = (props) => ({
  getHistoryConsumptionDashboard: props.license.getHistoryConsumptionDashboard,
  getRequestDashboard: props.license.getRequestDashboard,
  showMessageAlert: props.general.showMessageAlert,
});

const mapDispatchToProps = {
  getHistoryConsumptionDataDashboard: getHistoryConsumptionDataDashboardAction,
  clearMessageAlert: clearMessageAlertAction,
  getClearHistoryConsumptionDataDashboard: getClearHistoryConsumptionDataDashboardAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Movements);
